import { useState } from 'react';
import { applyDiscountCode } from '../api/discounts';

export function DiscountCode({ subtotal, applied, onApply, onRemove }) {
  const [code, setCode] = useState('');
  const [feedback, setFeedback] = useState(null);

  function handleApply(e) {
    e.preventDefault();
    const result = applyDiscountCode(code, subtotal);
    setFeedback(result);
    if (result.valid) onApply(result);
  }

  function handleRemove() {
    setCode('');
    setFeedback(null);
    onRemove();
  }

  return (
    <div className="rounded-2xl border border-white/10 bg-card p-5">
      <h2 className="mb-3 text-sm font-extrabold uppercase tracking-wide text-text-muted">
        Discount code
      </h2>

      {applied ? (
        <div className="flex items-center justify-between rounded-xl border border-accent/20 bg-accent-dim px-4 py-3">
          <div>
            <div className="text-sm font-bold text-accent">{applied.discount.code}</div>
            <div className="text-xs text-text-muted">{applied.discount.label}</div>
          </div>
          <button
            type="button"
            onClick={handleRemove}
            className="text-xs font-bold text-text-muted hover:text-text"
          >
            Remove
          </button>
        </div>
      ) : (
        <form onSubmit={handleApply} className="flex gap-2">
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter code"
            className="flex-1 rounded-full border border-white/10 bg-bg3 px-4 py-2.5 text-sm uppercase tracking-wide text-text placeholder:normal-case placeholder:text-text-dim outline-none focus:border-accent/40"
          />
          <button
            type="submit"
            className="shrink-0 rounded-full border border-white/10 px-5 py-2.5 text-sm font-bold transition-colors hover:border-accent/40 hover:text-accent"
          >
            Apply
          </button>
        </form>
      )}

      {!applied && feedback && (
        <p className={`mt-2 text-xs ${feedback.valid ? 'text-accent' : 'text-[#ff4d4d]'}`}>
          {feedback.message}
        </p>
      )}
    </div>
  );
}
